import type { FC } from 'react'
import Icon from '../common/Icon'

const VoiceListingEmpty: FC = () => (
  // TODO: use a design from figma whenever it's available
  <div className="flex min-h-[400px] w-full flex-col items-center justify-center">
    <Icon name="speech" fill="#9ca3af" width={40} height={40} />
    <span className="text-sm text-gray-400">No voices found</span>
  </div>
)

export default VoiceListingEmpty
